import {
  CircleDollarSign,
  CodeXml,
  CopyPlus,
  FileImage,
  Gift,
  LayoutPanelTop,
  LucideIcon,
  MessageSquareText,
  Newspaper,
  PencilRuler,
  Shapes,
  ShieldCheck,
  Shirt,
  ShoppingBag,
  ShoppingBasket,
  Split,
  SquareStack,
  Tag,
  Truck,
} from "lucide-react";

export const EXPERIENCE_TYPE_ICONS: Record<string, LucideIcon> = {
  splitUrl: Split,
  onsiteEdits: PencilRuler,
  onsiteInjections: CodeXml,
  theme: LayoutPanelTop,
  template: LayoutPanelTop,
  price: CircleDollarSign,
  pricing: CircleDollarSign,
  shipping: Truck,
  "content/advanced": PencilRuler,
  "content/onsiteEdits": PencilRuler,
  "content/url": Split,
  "content/template": LayoutPanelTop,
  "content/theme": LayoutPanelTop,
  "personalization/offer": Tag,
  checkoutBlock: Shapes,
  onsiteUpsell: Newspaper,
  postPurchase: ShoppingBag,
  content: PencilRuler,
  sitewide: PencilRuler,
  personalization: Tag,
  offer: Tag,
  cartDiscount_perItem: Shirt,
  cartDiscount_perOrder: ShoppingBasket,
  tieredDiscount: SquareStack,
  freeShipping: Truck,
  freeGift: Gift,
  buyXGetY: CopyPlus,
  checkoutBlock_badgeTiles: ShieldCheck,
  checkoutBlock_callOut: MessageSquareText,
  checkoutBlock_images: FileImage,
} as const;
